module.exports = __webpack_public_path__ + "img/10-九寨沟.687ab3c2.jpg";